import * as React from 'react'

const SceneContext = React.createContext<Phaser.Scene | null>(null)

export default SceneContext
